import React from "react";
import { useTranslation } from "react-i18next";
import Styles from "../../../components/Styles";
import Footer from "../../../components/Footer";
import Copyrights from "../../../components/Copyrights";
import HotelDetails from "./HotelDetails";
import HotelBanner from "../../../components/hotel/Banner";
import { useParams, useLocation } from "react-router-dom";
import Header from "../../../components/Header";
import { useEffect, useState } from "react";

const HotelDetailsPage = () => {
  const { t } = useTranslation();
  const translationContext = useTranslation();

  // Get hotelId from URL params
  const { hotelId } = useParams();

  // Get state (hotelSearchData, searchId, offerId) from navigation
  const location = useLocation();
  const routeState = location.state;

  // Detect mobile viewport
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Debug log për të verifikuar datat që vijnë nga Results.jsx
  
  // Kontrollojmë nëse ka datat në hotelSearchData.offers
  if (routeState?.hotelSearchData?.offers && routeState.hotelSearchData.offers.length > 0) {
    const offer = routeState.hotelSearchData.offers[0];
    
    if (offer.checkIn && offer.night) {
      const checkOutDate = new Date(offer.checkIn);
      checkOutDate.setDate(checkOutDate.getDate() + offer.night);
    }
  }

  return (
    <div style={{ 
      backgroundColor: "white",
      position: 'relative',
      overflow: 'visible',
      minHeight: '100vh'
    }}>
      {/* Global styles and components */}
      <Styles />
      {!isMobile && (
      <Header translation={t} translationContext={translationContext} />
      )}
      <div style={{ position: 'relative', zIndex: 2 }}>
        <HotelBanner translation={translationContext.t} translationContext={translationContext} />
      </div>

      {/* Main content area with padding and margin to avoid overlap */}
      <div
        className="container"
        style={{
          marginTop: "120px",
          marginBottom: "60px",
          paddingLeft: "15px",
          paddingRight: "15px",
          maxWidth: "1400px",
          position: 'relative',
          zIndex: 1
        }}
      >
        {/* Hotel Details component with correct props */}
        <HotelDetails 
          hotelId={hotelId} 
          routeState={routeState} 
          address={routeState?.address}
          checkInDate={routeState?.checkInDate || (routeState?.hotelSearchData?.offers?.[0]?.checkIn)}
          checkOutDate={routeState?.checkOutDate || (() => {
            const offer = routeState?.hotelSearchData?.offers?.[0];
            if (offer?.checkIn && offer?.night) {
              const checkOut = new Date(offer.checkIn);
              checkOut.setDate(checkOut.getDate() + offer.night);
              return checkOut.toISOString().split('T')[0];
            }
            return null;
          })()}
          translation={t}
        />
      </div>

      {/* Footer and copyrights */}
      <Footer />
      <Copyrights />
    </div>
  );
};

export default HotelDetailsPage;
